export const vptiny = () => {
    return !!(window.matchMedia(`(max-width: 420px)`).matches);
};
